import React, { Component } from 'react';
import { Portal } from 'react-portal';

import {
  SR_API_ACTION_ADMIN_REQUEST_TOUR_SHOWING,
} from 'api/actionTypes';
import {
  DATA_TABLE_SOURCE_ADMIN_TOURS,
} from 'common/dataTableConstants';

import {
  actionDataTableReset,
} from 'client/helpers/dataTables';
import extractPhoneFromText from 'common/util/extractPhoneFromText';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import withApiState from 'client/helpers/withApiState';
import branch from 'client/core/branch';

@withApiState({
  requestShowingApiState: {
    action: SR_API_ACTION_ADMIN_REQUEST_TOUR_SHOWING,
  },
})
@branch({})
class SrAdminToursRequestTourAsAUserModal extends Component {
  constructor(props, context) {
    super(props, context);

    this.initialState = {
      userPhone: '',
      listingId: '',
      listingMlsNumberOrSmartApartmentId: '',
    };
    this.state = this.initialState;
  }

  _onUserPhoneChange = (event) => {
    const newUserPhone = event.target.value.trim();
    if (
      (newUserPhone[0] === '+' && newUserPhone.length > 12) ||
      (newUserPhone[0] !== '+' && newUserPhone.length > 10)
    ) {
      return;
    }

    this.setState({
      userPhone: event.target.value,
    });
  }

  _onListingMlsNumberChange = (event) => {
    this.setState({
      listingId: '',
      listingMlsNumberOrSmartApartmentId: event.target.value,
    });
  }

  _onListingIdChange = (event) => {
    this.setState({
      listingId: event.target.value,
      listingMlsNumberOrSmartApartmentId: '',
    });
  }

  _onSubmit = () => {
    const { dispatch, onClose } = this.props;
    const { userPhone, listingMlsNumberOrSmartApartmentId, listingId } = this.state;

    dispatch(({ apiClient, state }) => apiClient.postWithState({
      action: SR_API_ACTION_ADMIN_REQUEST_TOUR_SHOWING,
      state: state,
      payload: {
        userPhone: extractPhoneFromText(userPhone),
        listingId: listingId ? parseInt(listingId, 10) : null,
        listingMlsNumberOrSmartApartmentId,
      },
      onSuccess: () => {
        this.setState(this.initialState);
        dispatch(actionDataTableReset, {
          dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        });
        onClose();
      },
    }));
  }

  render() {
    const {
      userPhone,
      listingId,
      listingMlsNumberOrSmartApartmentId,
    } = this.state;

    const {
      requestShowingApiState,
      onClose,
      isOpen,
    } = this.props;

    const isDisabled = (
      !extractPhoneFromText(userPhone)
      || requestShowingApiState.inProgress
      || (!listingMlsNumberOrSmartApartmentId && !listingId)
    );

    if (!isOpen) {
      return null;
    }

    return (
      <Portal>
        <div className='optionSelectionModal'>
          <div className='backdrop' onClick={onClose}>
            <div className='form' onClick={(evt) => evt.stopPropagation()}>
              <h1>request tour as user</h1>
              <input
                onChange={this._onUserPhoneChange}
                value={userPhone}
                placeholder='Phone'
              />
              <input
                onChange={this._onListingMlsNumberChange}
                value={listingMlsNumberOrSmartApartmentId}
                placeholder='MLS / Smart Apartment ID'
              />
              <input
                onChange={this._onListingIdChange}
                value={listingId}
                placeholder='Listing ID'
              />
              <ButtonDeprecated onClick={this._onSubmit} disabled={isDisabled}>
                {requestShowingApiState.inProgress ? 'requesting...' : 'request as user'}
              </ButtonDeprecated>
              {requestShowingApiState.error && (
                <div className='errorMessage'>
                  {requestShowingApiState.error.message}
                </div>
              )}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrAdminToursRequestTourAsAUserModal.displayName = 'SrAdminToursRequestTourAsAUserModal';

export default SrAdminToursRequestTourAsAUserModal;
